export default __webpack_public_path__ + "static/media/hannah-testi.ab2a12e2.jpg";